import { axiosClient, getCSRFToken } from 'www/utils'
import type {
  ApiCheckDocumentPostParams, ApiCheckDocumentPostResponse,
} from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/api/apiCheckDocument.types'

export default {
  async post(
    { file }: ApiCheckDocumentPostParams,
    onUploadProgress?: (_event: any) => void,
  ): Promise<ApiCheckDocumentPostResponse> {
    const requestData = new FormData()

    requestData.append('image', file, file.name)

    return axiosClient.post<ApiCheckDocumentPostResponse>('/api/rates/check/document/', requestData, {
      headers: {
        'X-CSRFToken': getCSRFToken(),
      },
      onUploadProgress,
    }).then(({ data }) => data)
  },
}
